import { render, staticRenderFns } from "./purchase-gain-amount.vue?vue&type=template&id=6d9978c0&"
import script from "./purchase-gain-amount.vue?vue&type=script&lang=js&"
export * from "./purchase-gain-amount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports